import React from 'react';

interface ContentPageHeroProps {
  title: string;
  description?: string;
  backgroundImage?: string;
}

const ContentPageHero: React.FC<ContentPageHeroProps> = ({ title, description, backgroundImage }) => {
  const sectionStyle = backgroundImage
    ? {
      backgroundImage: `linear-gradient(rgba(26, 54, 93, 0.7), rgba(15, 39, 68, 0.85)), url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'white'
    }
    : {};
  return (
    <section className="hero-section" style={sectionStyle}>
      <div className="container">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
    </section>
  );
};

export default ContentPageHero;